import { create } from 'zustand';
type Store = {
  docked: boolean;
  dockedMode: boolean;
  toggleDock: () => void;
  toggleDockMode: () => void;
};
export const useWidgetStore = create<Store>((set) => ({
  dockedMode: false,
  docked: false,
  toggleDockMode() {
    set((state) => ({ dockedMode: !state.dockedMode }));
  },
  toggleDock() {
    set((state) => ({ docked: !state.docked }));
  }
}));
